module.exports = __webpack_public_path__ + "static/media/shadowsocks.c4ccdf32.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/shadowsocks.png
// module id = 190
// module chunks = 0